<template>
  <sidebar-item
    @dashLoading="dashLoading"
    @load-icon-content="loadIconContent"
    :link="{
      id: menuModule.id,
      name: translateDataBaseText(menuModule.name, menuModule.other_value),
      icon: menuModule.icon,
      path: '/' + menuModule.url,
      icon_right: menuModule.icon_right,
    }"
  >
    <sidebar-item
      v-for="(mod, index) in getLevelTwoModules(menuModule.children)"
      :key="index"
      @dashLoading="dashLoading"
      @load-icon-content="loadIconContent"
      :link="{
        id: mod.id,
        name: translateDataBaseText(mod.name, mod.other_value),
        icon: mod.icon,
        path: '/' + mod.url,
        icon_right: menuModule.icon_right,
      }"
    >
    </sidebar-item>
  </sidebar-item>
</template>
<script>
import MixinMenu from 'src/util/mixinMenu';
import MixinTranslate from 'src/util/mixinTranslate';

export default {
  name: 'activate-menu',
  props: {
    userModules: {
      type: Array,
      default: () => [],
    },
    menuModule: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [MixinMenu, MixinTranslate],
  methods: {
    dashLoading(value) {
      this.$emit('dashLoading', value);
    },

    loadIconContent(icon) {
      this.$emit('loadIconContent', icon);
    },
  },
};
</script>
